module.exports = require('./lib/patch')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 3
// module chunks = 0